// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"185ecaea","239":"4998d652","667":"b2b9c130"}[chunkId] + ".chunk.js";
};